var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragDropActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.67,
    height: 42.67,
    viewBox: "0 0 42.67 42.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drag",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1213",
    "data-name": "Grupo 1213",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1212",
    "data-name": "Grupo 1212",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_924",
    "data-name": "Caminho 924",
    d: "M187.29,13.935a2.731,2.731,0,0,0-1.778.64v-.64a3.5,3.5,0,0,0-3.2-3.556,2.731,2.731,0,0,0-1.778.64,3.542,3.542,0,0,0-3.2-3.485,2.731,2.731,0,0,0-1.778.64V2.556a3.218,3.218,0,1,0-6.4,0V17.633a12.981,12.981,0,0,0-2.347-3.485,3.743,3.743,0,0,0-4.694-.142c-.356.356-1.565,1.636.071,3.911,1.493,2.134,2.7,6.827,2.7,9.53a9.928,9.928,0,0,0,4.978,8.961v4.551a.711.711,0,1,0,1.422,0V35.981a.684.684,0,0,0-.427-.64,8.467,8.467,0,0,1-4.551-7.894c0-2.631-1.138-7.823-2.987-10.383-.5-.64-.924-1.493-.284-1.991a2.347,2.347,0,0,1,2.774.071,13.6,13.6,0,0,1,3.343,7.325.711.711,0,1,0,1.422,0V2.556a1.808,1.808,0,1,1,3.556,0V18.2a.711.711,0,1,0,1.422,0V11.09a1.808,1.808,0,1,1,3.556,0v7.823a.711.711,0,1,0,1.422,0V13.935a1.808,1.808,0,1,1,3.556,0v6.4a.711.711,0,0,0,1.422,0V17.348c.071-.924.853-1.991,1.778-1.991a2.1,2.1,0,0,1,1.778,2.134v9.956c0,5.4,0,5.4-1.991,8.107a.677.677,0,0,0-.142.5v4.907a.711.711,0,1,0,1.422,0V36.194c2.134-2.845,2.134-3.2,2.134-8.747V17.49A3.5,3.5,0,0,0,187.29,13.935Z",
    transform: "translate(-147.82 1)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_925",
    "data-name": "Caminho 925",
    d: "M59.943,2.343l.924-.924v2.56a.711.711,0,0,0,1.422,0V1.418l.924.924a.687.687,0,0,0,1,0,.688.688,0,0,0,0-1L62.2-.665A.676.676,0,0,0,61.579-1h0a.676.676,0,0,0-.619.335L58.948,1.347a.688.688,0,0,0,0,1A.687.687,0,0,0,59.943,2.343Z",
    transform: "translate(-53.756 1)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_926",
    "data-name": "Caminho 926",
    d: "M63.213,120.814l-.924.924v-2.56a.711.711,0,1,0-1.422,0v2.56l-.925-.924a.7.7,0,0,0-1,1l2.012,2.012a.74.74,0,0,0,1.239,0l2.012-2.012a.7.7,0,0,0-1-1Z",
    transform: "translate(-53.755 -108.511)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_927",
    "data-name": "Caminho 927",
    d: "M124.156,61.578h0a.676.676,0,0,0-.335-.62l-2.012-2.012a.7.7,0,0,0-1,1l.924.924h-2.56a.711.711,0,1,0,0,1.422h2.56l-.924.924a.688.688,0,0,0,0,1,.687.687,0,0,0,1,0l2.012-2.012A.675.675,0,0,0,124.156,61.578Z",
    transform: "translate(-108.511 -53.755)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_928",
    "data-name": "Caminho 928",
    d: "M1.418,62.289h2.56a.711.711,0,0,0,0-1.422H1.418l.925-.925a.688.688,0,0,0,0-1,.687.687,0,0,0-1,0L-.665,60.958A.676.676,0,0,0-1,61.578h0a.676.676,0,0,0,.335.62l2.012,2.012a.646.646,0,0,0,.5.213.645.645,0,0,0,.5-.213.688.688,0,0,0,0-1Z",
    transform: "translate(1 -53.755)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_929",
    "data-name": "Caminho 929",
    d: "M351.712,418.556a.711.711,0,1,0,0-1.422h-2.133a.711.711,0,1,0,0,1.422Z",
    transform: "translate(-319.709 -382.287)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_930",
    "data-name": "Caminho 930",
    d: "M344.6,451.267h-3.556a.711.711,0,1,0,0,1.422H344.6a.711.711,0,0,0,0-1.422Z",
    transform: "translate(-311.886 -413.575)",
    fill: "#d4af37"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDropActivity);
export default __webpack_public_path__ + "static/media/dragDropActivity.5f443a7e1cd7afa34f0a9b81830048b8.svg";
export { ForwardRef as ReactComponent };